import { render, staticRenderFns } from "./RegReports.vue?vue&type=template&id=9170f600"
import script from "./RegReports.vue?vue&type=script&lang=js"
export * from "./RegReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports